import {IdName} from '@domain/id-name';
import {Unit} from '@vdw/angular-component-library';
import {first, map, size} from 'lodash-es';
import {Thread} from './thread';

export class YarnType {
  private _id: number;
  private _name: string;
  private _description: string;
  private _yarnCount: number;
  private _yarnCountUnit: string;
  private _threads: Thread[];
  private _groupName: string;
  private _comment: string;
  private readonly _used: boolean;

  public constructor(id: number, name: string, description: string, yarnCount: number, yarnCountUnit: string, threads: Thread[], groupName: string, comment: string, used: boolean) {
    this._id = id;
    this._name = name;
    this._description = description;
    this._yarnCount = yarnCount;
    this._yarnCountUnit = yarnCountUnit;
    this._threads = threads;
    this._groupName = groupName;
    this._comment = comment;
    this._used = used;
  }

  public get id(): number {
    return this._id;
  }

  public set id(value: number) {
    this._id = value;
  }

  public get name(): string {
    return this._name;
  }

  public set name(name: string) {
    this._name = name;
  }

  public get description(): string {
    return this._description;
  }

  public get yarnCount(): number {
    return this._yarnCount;
  }

  public get yarnCountUnit(): string {
    return this._yarnCountUnit;
  }

  public get threads(): Thread[] {
    return this._threads;
  }

  public get groupName(): string {
    return this._groupName;
  }

  public get comment(): string {
    return this._comment;
  }

  public get used(): boolean {
    return this._used;
  }

  public static createEmptyYarnType(): YarnType {
    return new YarnType(null, null, null, null, null, null, null, null, null);
  }

  public static fromJSON(yarnTypeJSON: any): YarnType {
    const threads: Thread[] = map(yarnTypeJSON.threads, (threadJSON: any) => {
      return new Thread(threadJSON.yarnCount, threadJSON.spaceDye, new IdName(threadJSON.rawMaterialView.id, threadJSON.rawMaterialView.name));
    });

    return new YarnType(
      yarnTypeJSON.id,
      yarnTypeJSON.name,
      yarnTypeJSON.description,
      yarnTypeJSON.yarnCount,
      Unit[yarnTypeJSON.yarnCountUnit],
      threads,
      yarnTypeJSON.groupName,
      yarnTypeJSON.comment,
      yarnTypeJSON.used
    );
  }

  public getFirstRawMaterial(): string {
    return size(this.threads) > 0 ? first(this.threads).rawMaterialView.name : '';
  }

  public toJSON(): JSON {
    return {
      name: this._name,
      description: this._description,
      yarnCount: this._yarnCount ?? 0,
      yarnCountUnit: Unit.getKeyFromValue(this._yarnCountUnit),
      threads: map(this._threads, (thread: Thread) => {
        return {
          yarnCount: thread.yarnCount ?? 0,
          spaceDye: thread.spaceDye,
          rawMaterialId: thread.rawMaterialView.id
        };
      }),
      groupName: this._groupName,
      comment: this._comment
    } as any as JSON;
  }
}
